import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { AuthGuard } from './services/permission.guard';
import { LoginComponent } from './views/login/login.component';
import { CategoryComponent } from './views/category/category.component';
import { OrganizationUnitsComponent } from './admin/views/organization-units/organization-units.component';
import { AddUnitComponent } from './admin/views/organization-units/add-unit/add-unit.component';
import { CategoriesComponent } from './admin/views/organization-units/categories/categories.component';
import { TypesComponent } from './admin/views/organization-units/types/types.component';
import { LocationsComponent } from './admin/views/organization-units/locations/locations.component';
import { SignupComponent } from './views/signup/signup.component';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { UserMmanagementComponent } from './admin/views/user-mmanagement/user-mmanagement.component';
import { CreateUserComponent } from './admin/views/user-mmanagement/create-user/create-user.component';

import { RoleManagementComponent } from './admin/views/roles/role-management/role-management.component';
import { PositionComponent } from './admin/views/roles/position/position.component';
import { PermissionsComponent } from './admin/views/roles/permissions/permissions.component';
import { RoleInterfaceComponent } from './admin/views/roles/role-interface/role-interface.component';

import { DataComponent } from './admin/views/data/data.component';
import { AddComponent } from './admin/views/data/add/add.component';
import { BulkComponent } from './admin/views/data/bulk/bulk.component';
import { DataTypesComponent } from './admin/views/data/data-types/data-types.component';
import { DataTemplatesComponent } from './admin/views/data/data-templates/data-templates.component';
import { DataFieldsComponent } from './admin/views/data/data-fields/data-fields.component';
import { DataFieldTypesComponent } from './admin/views/data/data-field-types/data-field-types.component';
import { ActivateAccountComponent } from './views/login/activate-account/activate-account.component';
import { ContentUpdatePageComponent } from './admin/views/data/content-update-page/content-update-page.component';
import { ViewComponent } from './admin/views/knowledge_library/view/view.component';
import { KLibraryAdminComponent } from './admin/views/knowledge_library/admin/klibrary_admin.component';
import { KCategoryComponent } from './admin/views/knowledge_library/k-category/k-category.component';
import { CreatePermissionComponent } from './admin/views/roles/permissions/create-permission/create-permission.component';
import { UserProfileComponent } from './views/user-profile/user-profile.component';
import { CommentsComponent } from './admin/views/comments/comments.component';
import { SearchResultComponent } from './views/category/search-result/search-result.component';
import { TrainingRequestComponent } from './admin/views/training/training-request/training-request.component';
import { TrainingTypeComponent } from './admin/views/training/training-type/training-type.component';
import { ViewTrainingRequestsComponent } from './admin/views/training/view-training-requests/view-training-requests.component';
import { SurveyTypeComponent } from './admin/views/survey/survey-type/survey-type.component';
import { SurveyComponent } from './admin/views/survey/survey.component';
import { AddQuestionComponent } from './admin/views/survey/add-question/add-question.component';
import { ViewCourseComponent } from './admin/course/view-course/view-course.component';
import { AssignUsersComponent } from './assign-users/assign-users.component';
import { SurveyViewComponent } from './admin/views/survey/survey-view/survey-view.component';
import { NotificationComponent } from './notification/notification.component';
import { AddCategoryComponent } from './admin/views/training/add-category/add-category.component';
import { AdvanceSearchComponent } from './views/category/advance-search/advance-search.component';
import { DashboardsComponent } from './admin/views/dashboards/dashboards.component';
import { AddnewdashboardComponent } from './admin/views/dashboards/addnewdashboard/addnewdashboard.component';
import { SearchViewComponent } from './views/category/search-view/search-view.component';

import { ListServicesComponent } from './views/category/list-services/list-services.component';
import { SingleDataViewComponent } from './views/single-data-view/single-data-view.component';
import { TaskDetailViewComponent } from './admin/views/training/task-detail-view/task-detail-view.component';

import { UserSurveyResultComponent } from './admin/views/survey/user-survey-result/user-survey-result.component';
import { SurveyAttendanceComponent } from './admin/views/survey/survey-attendance/survey-attendance.component';

import { CompanyComponent } from './admin/views/company/company.component';
import { AddExternalUserComponent } from './admin/views/company/add-external-user/add-external-user.component';
import { AddExternalCoordinatorComponent } from './admin/views/company/add-external-coordinator/add-external-coordinator.component';
import { CoordinatorViewComponent } from './admin/views/company/coordinator-view/coordinator-view.component';
import { ViewTrainersComponent } from './admin/views/company/view-trainers/view-trainers.component';
import { NewBranchTrainingRequestsComponent } from './admin/views/training/new-branch-training-requests/new-branch-training-requests.component';
import { SurveyTagsManagementComponent } from './admin/views/survey/survey-tags-management/survey-tags-management.component';
import { AssessmentComponent } from './admin/views/assessment/assessment.component';
import { AssessmentResultsComponent } from './admin/views/assessment/assessment-results/assessment-results.component';
import { SkillTrainingRequestsComponent } from './admin/views/training/skill-training-requests/skill-training-requests.component';
import { TrainingDashboardComponent } from './admin/views/training/training-dashboard/training-dashboard.component';
import { QuestionBankListComponent } from './admin/views/assessment/question-bank-list/question-bank-list.component';
import { MysteryShopperComponent } from './mystery-shopper/mystery-shopper.component';
import { AllDataViewComponent } from './views/all-data-view/all-data-view.component';

import { MsVendorComponent } from './admin/views/mystery-shopper/ms-vendor/ms-vendor.component';
import { MsResponsibleComponent } from './admin/views/mystery-shopper/ms-responsible/ms-responsible.component';
import { MsProjectComponent } from './admin/views/mystery-shopper/ms-project/ms-project.component';
import { AddProjectComponent } from './admin/views/mystery-shopper/ms-project/add-project/add-project.component';
import { MsMeasuringTypesComponent } from './admin/views/mystery-shopper/ms-measuring-types/ms-measuring-types.component';
import { MsFactorComponent } from './admin/views/mystery-shopper/ms-factor/ms-factor.component';
import { MsCriteriaComponent } from './admin/views/mystery-shopper/ms-criteria/ms-criteria.component';
import { MsDashboardComponent } from './admin/views/mystery-shopper/ms-dashboard/ms-dashboard.component';
import { AssignWeightsComponent } from './admin/views/mystery-shopper/assign-weights/assign-weights.component';
import { MsCalenderComponent } from './admin/views/mystery-shopper/ms-calender/ms-calender.component';
import { MsEvaluationComponent } from './admin/views/mystery-shopper/ms-evaluation/ms-evaluation.component';
import { MsFactorDashboardComponent } from './admin/views/mystery-shopper/ms-factor-dashboard/ms-factor-dashboard.component';
import { MsFactorReportsComponent } from './admin/views/mystery-shopper/ms-factor-reports/ms-factor-reports.component';
import { FactorForwardingComponent } from './admin/views/mystery-shopper/ms-factor/factor-forwarding/factor-forwarding.component';
import { MsSessionComponent } from './admin/views/mystery-shopper/ms-session/ms-session.component';
import { TrainingPageComponent } from './training-page/training-page.component';
import { KlApprovalComponent } from './admin/views/training/kl-approval/kl-approval.component';
import { AssessmentTopicsComponent } from './admin/views/assessment/assessment-topics/assessment-topics.component';
import { BulkResultsComponent } from './admin/views/assessment/bulk-results/bulk-results.component';
import { AssessmentCertificateComponent } from './admin/views/assessment/assessment-certificate/assessment-certificate.component';
import { TrainingRatingComponent } from './admin/views/training/training-rating/training-rating.component';
import { InvestorControllerComponent } from './investor-controller/investor-controller.component';
import { RatingGraphComponent } from './admin/views/training/rating-graph/rating-graph.component';
import { TrainingResultsComponent } from './admin/views/training/training-results/training-results.component';
import { TrainingProgramComponent } from './training-program/training-program.component';
import { UpdateDatesComponent } from './training-program/update-dates/update-dates.component';
import { TrainingUserManagementComponent } from './admin/views/training/training-user-management/training-user-management.component';
import { ManagerImpactTaskComponent } from './training-page/manager-impact-task/manager-impact-task.component';
import { ProgramUserManagmentComponent } from './admin/views/training/program-user-managment/program-user-managment.component';
import { TrainingRevampComponent } from './views/home/training-revamp/training-revamp.component';
import { AnnouncementComponent } from './admin/views/announcement/announcement.component';
import { AnnouncementResultsComponent } from './admin/views/announcement/announcement-results/announcement-results.component';
import { SurveyRedirectGuard } from './guards/survey-redirect.guard';
import { RedirectSurveyComponent } from './misc/redirect-survey-component/redirect-survey-component.component';
import { PreodicReportsComponent } from './preodic-reports/preodic-reports.component';

const routes: Routes = [
  //Open Routes
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'category/:id', component: CategoryComponent },
  { path: 'category/search/:searchquery', component: SearchResultComponent },
  { path: 'list-services/:id/:type', component: ListServicesComponent },
  { path: 'data/:id', component: SingleDataViewComponent },
  {
    path: 'category/search/:categoryid/:searchquery',
    component: SearchResultComponent,
  },

  //Protected Rroutes
  {
    path: 'search-view',
    component: SearchViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/organization-units',
    component: OrganizationUnitsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/organization-units/categories',
    component: CategoriesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/organization-units/types',
    component: TypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/organization-units/locations',
    component: LocationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users',
    component: UserMmanagementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users/roles',
    component: RoleManagementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users/roles/permission',
    component: PermissionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users/create',
    component: CreateUserComponent,
    canActivate: [AuthGuard],
  },
  { path: 'admin/data', component: DataComponent, canActivate: [AuthGuard] },
  { path: 'admin/data/add', component: AddComponent, canActivate: [AuthGuard] },
  {
    path: 'bulk',
    component: BulkComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/data/types',
    component: DataTypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/data/templates',
    component: DataTemplatesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/data/fields',
    component: DataFieldsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/data/fields/types',
    component: DataFieldTypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'update',
    component: ContentUpdatePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users/roles/permission/add',
    component: CreatePermissionComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'all-data-view',
    component: AllDataViewComponent,
    canActivate: [AuthGuard],
  },
  { path: 'update-dates', component: UpdateDatesComponent },

  {
    path: 'knowledge-library',
    component: ViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'knowledge-library/approval',
    component: KlApprovalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'advance-search',
    component: AdvanceSearchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'advance-search/result',
    component: SearchViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'training/request',
    component: TrainingRequestComponent,
    canActivate: [AuthGuard],
  },
  // { path: 'training/program', component: TrainingProgramComponent }, // canActivate: [AuthGuard],
  {
    path: 'training/training-results/:courseId',
    component: TrainingResultsComponent,
  },
  {
    path: 'training/new-branch',
    component: NewBranchTrainingRequestsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'training/skill-training/:typeId',
    component: SkillTrainingRequestsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'notification',
    component: NotificationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'training/type',
    component: TrainingTypeComponent,
    canActivate: [AuthGuard],
  },
  // { path: 'training/dashboard', component: TrainingDashboardComponent },
  {
    path: 'training/user-management/:courseId',
    component: TrainingUserManagementComponent,
  },
  {
    path: 'training/program-user-managment/:trainingProgramID',
    component: ProgramUserManagmentComponent,
  },
  {
    path: 'training/task-view',
    component: TaskDetailViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'training/training-page/:courseId',
    component: TrainingPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'training/impact-magerment-task',
    component: ManagerImpactTaskComponent,
  },
  {
    path: 'dashboard/knowledge-library',
    component: KLibraryAdminComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/knowledge-library/category',
    component: KCategoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/comments',
    component: CommentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/dashboards',
    component: DashboardsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/dashboards/add',
    component: AddnewdashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'announcement',
    component: AnnouncementComponent,
    // canActivate: [AuthGuard], faisal
  },
  {
    path: 'announcement/results/:Id',
    component: AnnouncementResultsComponent,
    // canActivate: [AuthGuard], faisal
  },
  {
    path: 'assessment',
    component: AssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment/all-results',
    component: BulkResultsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':from/results/:assessmentId',
    component: AssessmentResultsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment/certificate/:assessmentId/:email',
    component: AssessmentCertificateComponent,
  },
  {
    path: 'assessment/topics',
    component: AssessmentTopicsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'survey/survey-type',
    component: SurveyTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':from/tags-management',
    component: SurveyTagsManagementComponent,
    //canActivate: [AuthGuard], // Faisal
  },
  {
    path: ':from/attempt/:surveyId',
    component: SurveyViewComponent,
  },
  {
    path: 'survey',
    component: SurveyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':from/add-question/:questionId',
    component: AddQuestionComponent,
  },
  {
    path: 'mystery-shopper',
    component: MysteryShopperComponent,
    canActivate: [AuthGuard],
  },
  { path: 'ms/factor-reports', component: MsFactorReportsComponent },
  { path: 'ms/assign-weights/:projectId', component: AssignWeightsComponent },
  { path: 'ms/calender/:projectId', component: MsCalenderComponent },
  {
    path: 'ms/factor-dashboard/:projectId',
    component: MsFactorDashboardComponent,
  },
  { path: 'ms/evaluation/:projectId', component: MsEvaluationComponent },
  { path: 'ms/factor/:projectId', component: MsFactorComponent },
  { path: 'ms/criterias/:projectId', component: MsCriteriaComponent },
  { path: 'ms/vendor', component: MsVendorComponent },
  { path: 'ms/responsible', component: MsResponsibleComponent },
  { path: 'ms/project', component: MsProjectComponent },
  {
    path: 'ms/project/add',
    component: AddProjectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ms/project/update/:id',
    component: AddProjectComponent,
    canActivate: [AuthGuard],
  },
  { path: 'ms/measuring-types', component: MsMeasuringTypesComponent },
  { path: 'ms/dashboard/:projectId', component: MsDashboardComponent },
  {
    path: 'ms/factor-forward/:projectId',
    component: FactorForwardingComponent,
  },
  {
    path: 'ms/factor-update-status/:projectId',
    component: FactorForwardingComponent,
  },
  {
    path: 'ms/factor-status-approve/:projectId',
    component: FactorForwardingComponent,
  },
  { path: 'ms/session/:projectId', component: MsSessionComponent },

  // { path: 'add-category', component: AddCategoryComponent },
  {
    path: 'survey/attendance/:surveyId',
    component: SurveyAttendanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'user-survey-result/:surveyId/:email',
    canActivate: [SurveyRedirectGuard], // Redirect instantly,
    component: RedirectSurveyComponent
  },
  { path: 'company', component: CompanyComponent },
  { path: 'trainers', component: ViewTrainersComponent },
  {
    path: 'add-external-coordinator',
    component: AddExternalCoordinatorComponent,
  },
  {
    path: 'coordinator-view',
    component: CoordinatorViewComponent,
    canActivate: [AuthGuard],
  },
  { path: 'user-profile', component: UserProfileComponent },
  { path: 'password-change', component: ChangePasswordComponent },
  {
    path: 'investor-admin',
    component: InvestorControllerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'periodic-reports',
    component: PreodicReportsComponent,
    canActivate: [AuthGuard],
  },
  { path: 'account/activate', component: ActivateAccountComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'login', component: LoginComponent },
  { path: 'new-ui', component: TrainingRevampComponent },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
